import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import RelatedPostThumbnail from "./RelatedPostThumbnail";
import { fetchRelatedPosts } from "../../features/relatedPosts/relatedPostsSlice";
import Loading from "../ui/Loading";
import Message from "../ui/Message";
function RelatedPosts() {
  const dispatch = useDispatch();
  const { post } = useSelector((state) => state.post);
  const { isLoading, relatedPosts, error } = useSelector(
    (state) => state.relatedPosts
  );

  useEffect(() => {
    if (post?.id && post?.tags?.length > 0) {
      dispatch(fetchRelatedPosts({ id: post.id, tags: post.tags }));
    }
  }, [dispatch, post]);

  let content = null;

  if (isLoading) content = <Loading />;
  if (!isLoading && !!error)
    content = (
      <Message text={`Error Fetching Posts. Error Message: ${error}`} />
    );
  if (!isLoading && !error && relatedPosts?.length === 0)
    content = <Message text={"No Related Post Found!"} />;
  if (!isLoading && !error && relatedPosts?.length > 0)
    content = relatedPosts?.map((post) => (
      <RelatedPostThumbnail key={post.id} post={post} />
    ));

  return (
    <aside>
      <h4 className="mb-4 text-xl font-medium" id="lws-relatedPosts">
        Related Posts
      </h4>
      <div className="space-y-4 related-post-container">
        {/* <!-- related post  --> */}
        {content}
        {/* <!-- related post ends --> */}
      </div>
    </aside>
  );
}

export default RelatedPosts;
